import dayjs from 'dayjs'

export type RecurrenceUnit = 'day' | 'week' | 'month' | 'year'
export type RecurrenceEndType = 'date' | 'occurrences'

export type RecurringSchedule = {
  isRecurring: boolean
  repeatUnits: RecurrenceUnit
  repeatCount: number
  endType: RecurrenceEndType
  occurrences: number
  startDate: string
  endDate: string
}

export const defaultSchedule = (): RecurringSchedule => ({
  isRecurring: false,
  repeatUnits: 'week',
  repeatCount: 1,
  endType: 'occurrences',
  startDate: new Date().toISOString(),
  endDate: dayjs().add(1, 'week').toISOString(),
  occurrences: 1
})
